import React, { createContext, useContext, useEffect } from "react"
import { useApolloClient } from "@apollo/client"

import { GetRankingDatesDocument } from "../generated/graphql"
import {
	GetRankingDatesQuery,
	GetRankingDatesQueryVariables,
} from "../generated/graphql-operations"

const pref: {
	current: Promise<void> | undefined
} = {
	current: undefined,
}
const useCreateContext = () => {
	const client = useApolloClient()
	const data = client.cache.readQuery<
		GetRankingDatesQuery,
		GetRankingDatesQueryVariables
	>({
		query: GetRankingDatesDocument,
	})

	useEffect(() => {
		pref.current = undefined
	}, [data])

	if (!data) {
		if (pref.current) {
			throw pref.current
		}

		throw (pref.current = new Promise(async (res) => {
			try {
				await client.query<
					GetRankingDatesQuery,
					GetRankingDatesQueryVariables
				>({
					query: GetRankingDatesDocument,
				})
			} catch (e) {
				pref.current = undefined
				throw e
			}

			res()
		}))
	}

	return data
}
const RankingDateContext = createContext<ReturnType<
	typeof useCreateContext
> | null>(null)

export const useRankingDateContext = () => {
	const ctx = useContext(RankingDateContext)

	if (ctx === null) {
		throw new Error("No RankingDateContextProvider available.")
	}

	return ctx
}

export const RankingDateContextProvider: React.FC = ({ children }) => {
	const ctx = useCreateContext()

	return (
		<RankingDateContext.Provider value={ctx}>
			{children}
		</RankingDateContext.Provider>
	)
}
